import { apiUrl } from '../../../../../constants/global';
import axios from 'axios';
import { getLoggedUser } from '../../../../../state/user';

const user = getLoggedUser();
const endpoint = apiUrl + 'v2';

const config = () => ({
  headers: {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + user.token,
  },
});

async function getWinningAuctions(filters) {
  const query = new URLSearchParams(filters).toString();
  try {
    const { data: response } = await axios.get(`${endpoint}/auctions/winning?${query}`, config());
    return response;
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || 'Something went wrong' };
  }
}

async function getWinningClients() {
  try {
    const { data: response } = await axios.get(`${endpoint}/winning-organizations`, config());
    return response;
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || 'Something went wrong' };
  }
}

async function getUserDetails() {
  try {
    const { data: response } = await axios.get(`${endpoint}/profile`, config());
    return response;
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || 'Something went wrong' };
  }
}

async function getPaymentHistory() {
  try {
    const { data: response } = await axios.get(`${endpoint}/auction-payment`, config());
    return response;
  } catch (error) {
    console.error(error);
    return { success: false, data: [] };
  }
}

async function mzadcomPayment(payload, isFormData = false) {
  let cfg = config();
  if (isFormData) {
    cfg.headers['Content-Type'] = 'multipart/form-data';
  }
  try {
    const { data: response } = await axios.post(`${endpoint}/auction-payment`, payload, cfg);
    return response;
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || 'Something went wrong' };
  }
}

async function initiateOABPayment(payload) {
  try {
    const { data: response } = await axios.post(`${endpoint}/auction-payment/oab`, payload, config());
    return response;
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || 'Payment initiation failed' };
  }
}

export {
  getWinningAuctions,
  getWinningClients,
  getUserDetails,
  mzadcomPayment,
  getPaymentHistory,
  initiateOABPayment,
};